import useInputsContentArray from './hooks/use-inputs-section-content.hook';

export default function useStep3() {
	const { inputsSectionContent } = useInputsContentArray();

	return {
		inputsSectionContent,
	};
}
